import { DeviceType } from "@box/common/enums";

/**
 *  Returns the web store URL for the Box browser extension based on the device type.
 *  @defaults Box download page
 */
export const getWebStoreUrl = (deviceType: DeviceType): string => {
  switch (deviceType) {
    case DeviceType.ChromeBrowser:
      return "https://chromewebstore.google.com/detail/box-password-manage/nngceckbapebfimnlniiiahkandclblb";
    case DeviceType.FirefoxBrowser:
      return "https://addons.mozilla.org/en-US/firefox/addon/box-password-manager/";
    case DeviceType.SafariBrowser:
      return "https://apps.apple.com/us/app/box/id1352778147?mt=12";
    case DeviceType.OperaBrowser:
      return "https://addons.opera.com/extensions/details/box-free-password-manager/";
    case DeviceType.EdgeBrowser:
      return "https://microsoftedge.microsoft.com/addons/detail/jbkfoedolllekgbhcbcoahefnbanhhlh";
    default:
      return "https://box.com/download/#downloads-web-browser";
  }
};
